export const ANCHOR_PLAN_THEME_STORAGE_KEY = "anchor-plan-theme";

export type AnchorPlanTheme = "light" | "dark";

const VALID: readonly AnchorPlanTheme[] = ["light", "dark"];

export function getStoredTheme(): AnchorPlanTheme {
  if (typeof localStorage === "undefined") return "dark";
  try {
    const raw = localStorage.getItem(ANCHOR_PLAN_THEME_STORAGE_KEY);
    if (raw === "light" || raw === "dark") return raw;
  } catch {
    /* ignore */
  }
  return "dark";
}

export function setStoredTheme(theme: AnchorPlanTheme): void {
  if (typeof localStorage === "undefined") return;
  try {
    localStorage.setItem(ANCHOR_PLAN_THEME_STORAGE_KEY, theme);
  } catch {
    /* ignore */
  }
}

export function isAnchorPlanTheme(value: string): value is AnchorPlanTheme {
  return (VALID as readonly string[]).includes(value);
}

/** Застосувати тему на <html> для всього застосунку. */
export function applyThemeToDocument(theme: AnchorPlanTheme): void {
  if (typeof document === "undefined") return;
  document.documentElement.setAttribute("data-theme", theme);
  document.documentElement.style.colorScheme =
    theme === "light" ? "light" : "dark";
}

/** Прочитати --sem-* як конкретний колір (hex/rgb). Ланцюжок var() не розгортається. */
export function readCssColor(variable: string, fallback: string): string {
  if (typeof document === "undefined") return fallback;
  const value = getComputedStyle(document.documentElement)
    .getPropertyValue(variable)
    .trim();
  if (!value || value.startsWith("var(")) return fallback;
  return value;
}

/** Колір токена у rgba() для Chart.js. */
export function semRgba(
  variable: string,
  alpha: number,
  fallbackHex: string,
): string {
  const raw = readCssColor(variable, fallbackHex);
  const hex = raw.startsWith("#") ? raw : fallbackHex;
  const digits = hex.slice(1);
  const full =
    digits.length === 3
      ? digits
          .split("")
          .map((ch) => ch + ch)
          .join("")
      : digits;
  const r = Number.parseInt(full.slice(0, 2), 16);
  const g = Number.parseInt(full.slice(2, 4), 16);
  const b = Number.parseInt(full.slice(4, 6), 16);
  if ([r, g, b].some((n) => Number.isNaN(n))) return fallbackHex;
  return `rgba(${r},${g},${b},${alpha})`;
}

/** Прибрати атрибут теми після виходу з Anchor Plan. */
export function clearThemeFromDocument(): void {
  if (typeof document === "undefined") return;
  document.documentElement.removeAttribute("data-theme");
  document.documentElement.style.removeProperty("color-scheme");
}
